module.exports = __webpack_public_path__ + "static/media/Larry Ellison.f2a68b13.jpg";